type LeaveGuard = (action: () => void) => void;

// Modal and bulk navigation live above the post-scoped provider. Register only
// mounted forms so these existing entry points can ask that provider to leave.
const guards = new Map<string, LeaveGuard>();
const executing = new Set<string>();

export function registerPostMarkupLeaveGuard(
  postId: string,
  guard: LeaveGuard
) {
  guards.set(postId, guard);
  return () => {
    if (guards.get(postId) === guard) guards.delete(postId);
  };
}

export function requestPostMarkupLeave(
  postId: string | null | undefined,
  action: () => void
) {
  const guard =
    postId && !executing.has(postId) ? guards.get(postId) : undefined;
  if (!guard || !postId) {
    action();
    return;
  }
  guard(() => {
    executing.add(postId);
    try {
      action();
    } finally {
      executing.delete(postId);
    }
  });
}

export function requestAllPostMarkupLeave(
  postIds: string[],
  action: () => void
) {
  const [postId, ...remaining] = postIds;
  if (!postId) {
    action();
    return;
  }
  requestPostMarkupLeave(postId, () =>
    requestAllPostMarkupLeave(remaining, action)
  );
}
